import React, { Fragment, useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';

import styles from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js';

// material-ui icons
import Assignment from '@material-ui/icons/Assignment';
import EditIcon from '@material-ui/icons/Edit';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import BureauModal from './Modal/BureauModal';
import { WithApp } from 'contexts/appContext';
import { wsFindBy, wsCreate } from 'services/WService';

const StyleTable = {
  table: {
    minWidth: 800
  }
};

const useStyles = makeStyles(styles);
const useStyleTable = makeStyles(StyleTable);

export default WithApp(function Bureau(props) {
  const classes = useStyles();
  const claseTable = useStyleTable();

  const { businessPartner, showNotify } = props;

  const [bureaus, setBureaus] = useState([]);
  const [bureauId, setBureauId] = useState(null);

  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  async function listBureau() {
    let response = await wsFindBy(
      'base/customer-bureau',
      'base_business_partner_id',
      businessPartner.id
    );
    if (response.success) setBureaus(response.data);
  }

  async function regenerateBureaus() {
    let res = await wsCreate(`base/business-partner/${businessPartner.id}/regenerate-bureaus`);
    if (res.success) {
      showNotify(res.message);
      listBureau();
    } else {
      showNotify(res.message, 'error');
    }
  }

  useEffect(() => {
    listBureau();
  }, []);

  return (
    <Fragment>
      <BureauModal
        open={open}
        setOpen={setOpen}
        bureauId={bureauId}
        reload={listBureau}
        showNotify={showNotify}
      />
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              Mesas
              <Button size="sm" color="warning" style={{ marginLeft: '10px' }} onClick={regenerateBureaus}>Regenerar mesas</Button>
            </h4>

          </CardHeader>
          <CardBody>
            <TableContainer component={Paper}>
              <Table className={claseTable.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Dirección</TableCell>
                    <TableCell>Ruta</TableCell>
                    <TableCell>Mesa</TableCell>
                    <TableCell>Canal</TableCell>
                    <TableCell>Estado</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {bureaus.map((bureau, i) => {
                    return (
                      <TableRow key={i}>
                        <TableCell>
                          {i + 1}
                          <AllowedGuard
                            permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_BUREAU_UPDATE}
                          >
                            <Button
                              justIcon
                              round
                              simple
                              color={props.themeContext.buttonColorWarning}
                              size="sm"
                              className={classes.marginRight}
                              onClick={() => {
                                setBureauId(bureau.id);
                                handleClickOpen();
                              }}
                            >
                              <EditIcon />
                            </Button>
                          </AllowedGuard>
                        </TableCell>
                        <TableCell>{bureau.Address2}</TableCell>
                        <TableCell>{bureau.base_route_description}</TableCell>
                        <TableCell>{bureau.base_bureau_description}</TableCell>
                        <TableCell>{bureau.base_canal_description}</TableCell>
                        <TableCell>{bureau.state === 'A' ? 'Activo' : 'Inactivo'}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </CardBody>
        </Card>
      </GridItem>
    </Fragment>
  );
});
